export const lettersSpacingsAndWidths = {
    1300:{
        width: 250,
        spacing: 22
    },
    1000:{
        width: 250,
        spacing: 16
    },
    540:  {
        width: 300,
        spacing: 14,
    },
    410:  {
        width: 270,
        spacing: 13,
    },
    0: {
        width: 250,
        spacing: 12,
    },
}